import { ImportType } from "$types/import/ImportType";

// eslint-disable-next-line import/prefer-default-export
export const getEntityNameFromType = (
  type: ImportType,
  isPlural?: boolean
): string => {
  switch (type) {
    case ImportType.AGENCY_MULTIPLE:
      return `agence${isPlural ? "s" : ""}`;
    case ImportType.ORDER:
    case ImportType.ORDER_UPDATE:
      return `commande${isPlural ? "s" : ""}`;
    case ImportType.DOCKYARD_MULTIPLE:
    case ImportType.DOCKYARD_MULTIPLE_UPDATE:
    case ImportType.DOCKYARD_SIMPLE:
    case ImportType.DOCKYARD_SIMPLE_UPDATE:
      return `chantier${isPlural ? "s" : ""}`;
    case ImportType.EDB:
    case ImportType.EDB_UPDATE:
    case ImportType.DOCKYARD_EDB:
      return `expression${isPlural ? "s" : ""} de besoin`;
    case ImportType.PROJECT:
    case ImportType.PROJECT_UPDATE:
      return `projet${isPlural ? "s" : ""}`;
    case ImportType.PRODUCT:
    case ImportType.PRODUCT_DELETE:
    case ImportType.PRODUCT_UPDATE:
      return `produit${isPlural ? "s" : ""}`;
    case ImportType.RECEPTION:
    case ImportType.RECEPTION_READ:
      return `réception${isPlural ? "s" : ""}`;
    default:
      return "";
  }
};
